import { ROLES } from "./Acl";
import { DealerLocationID } from "./DealerLocation";

export type ExactCategoryID = number;

export type ExactCategoryLicenseID = number;

export type ExactDefaultCategoryID = number;

export enum EXACT_CATEGORIES {
  ManufacturerWarrantyManagerReceptionistDealerAdminConsultant = 1,
  SupervisorCallCenter = 2,
  CounterTablet = 3,
  GoogleAccount = 4,
  Mechanic = 5,
  DataHosting = 6,
  ClientCommunicationModule = 7,
  SMS = 8,
  KeyLocker = 9,
  TyreScanner = 10,
  TyreTeam = 11,
  Tablet = 12,
  LocationStartupCosts = 13,
  DealerStartupCosts = 14,
  OneIStartupCosts = 15,
  CombiUser = 16,
  TyreMotionAIMonthlyUsage = 17,
  AITranslationOnTablet = 18
}

export interface ExactCategory {
  created_on: string;
  updated_on: string;
  id?: ExactCategoryID; // Identifier of the ExactCategory, this can be nil because we generate categories that are yet to be created, identified by their type+role+location until they are actually created and get an ID
  is_unlinked_license_ignored: boolean; // Is the license ignored on the unlinked licenses page if it is not linked to a license
  is_unlinked_license_ignored_updated_by: string; // Name of the user that last updated the 'IsUnlinkedLicenseIgnored' status of this ExactCategory
  is_unlinked_license_ignored_updated_on: string | null; // Last time the 'IsUnlinkedLicenseIgnored' status of this ExactCategory was updated
  invoice_on: string | null; // For licenses that are only invoiced one time, indicates on which date they are invoiced
  one_time: boolean; // Is the item to be invoiced once or repeatedly
  visible_if_quantity_zero: boolean; // Is the category visible in the license overview if the quantity is 0
  invoiced: boolean; // Has an invoice for this category been sent, only for onetime categories
  license_category_type: EXACT_CATEGORIES; // The license category
  role_id?: ROLES; // User role of the users that use the tablets to be invoiced. Only applies to tablet categories
  dealer_location_id: DealerLocationID; // Identifier of the dealer location
  dealer_location_name?: string; // The name of the location of this license
  dealer_name?: string; // The name of the dealer of this license
  licenses?: ExactCategoryLicense[]; // The licenses for this category
  quantity?: number; // The quantity to be invoiced for this category
}

export interface ExactCategoryLicense {
  created_on: string;
  updated_on: string;
  id: ExactCategoryLicenseID;
  exact_item_id: string; // The Exact Online item to be invoiced
  price: number | null; // The Price of the item
  description: string; // Description of the item, if present it overrides the description of the item in exact only for this license
  category_id: ExactCategoryID; // Identifier of the category
  license_category?: ExactCategory;
}

export interface ExactDefaultCategory {
  visible_if_quantity_zero: boolean; // Is the category visible in the license overview if the quantity is 0
}
